import { EmissorOrderScreenStatus } from '../../types/emissor-order-history';
export const EMPTY_EMISSOR_ORDER_FILTERS = {
    competence: undefined,
    screenStatuses: [],
    productIds: [],
};
export const EMISSOR_ORDER_FILTER_STATUS_ORDER = [
    EmissorOrderScreenStatus.GENERATING_BILLING,
    EmissorOrderScreenStatus.PENDING_PAYMENT,
    EmissorOrderScreenStatus.RELEASING_CREDIT,
    EmissorOrderScreenStatus.CREDIT_RELEASED,
    EmissorOrderScreenStatus.CANCELLED,
];
export const EMISSOR_ORDER_FILTER_STATUS_LABELS = {
    [EmissorOrderScreenStatus.GENERATING_BILLING]: 'benefits.orders.filter.status.generating-billing',
    [EmissorOrderScreenStatus.PENDING_PAYMENT]: 'benefits.orders.filter.status.pending-payment',
    [EmissorOrderScreenStatus.RELEASING_CREDIT]: 'benefits.orders.filter.status.releasing-credit',
    [EmissorOrderScreenStatus.CREDIT_RELEASED]: 'benefits.orders.filter.status.credit-released',
    [EmissorOrderScreenStatus.CANCELLED]: 'benefits.orders.filter.status.cancelled',
};
export const hasEmissorOrderFilters = (filters) => Boolean(filters.competence || filters.screenStatuses.length || filters.productIds.length);
